import { FC } from 'react';
import { useParams, } from 'react-router-dom';

import { useGetCareersMedia, useGetCareersData } from '../../../../hooks/misc';

import DocumentFullPreview from '../../../sub_components/document_preview/DocumentFullPreview';
import Loader from '../../../reusables/Loader';


const ResumeFullPreview: FC = () => {
    const { studentId: studentIdParam, resumeId: resumeIdParam } = useParams();

    const studentId = studentIdParam ? parseInt(studentIdParam) : 0;
    const resumeId = resumeIdParam ? parseInt(resumeIdParam) : 0;

    const { data: careersData } = useGetCareersData(studentId);

    const resumeData = careersData?.resume_builds.find((resume_build) => resume_build.id === resumeId) ?? null;

    // Get the first media ID from the resume data
    const mediaId = resumeData?.medias?.[0]?.id;


    const { data: mediaData, isLoading } = useGetCareersMedia(
        studentId ? Number(studentId) : 0,
        mediaId ? Number(mediaId) : 0
    );

    if (!resumeData) {
        return <div>Resume not found</div>;
    }

    if (isLoading) {
        return <Loader type="full" text="Loading resume..." />;
    }

    // Use media URL if available, otherwise use fallback
    const pdfUrl = mediaData?.url;

    return (
        <DocumentFullPreview
            documentType="resume"
            pdfPath={pdfUrl ?? null}
            backRoute={`/students/${studentId}/resume`}
        />
    );
};

export default ResumeFullPreview;
